export { ReactComponent as AudienceIcon } from './audience.svg';
export { ReactComponent as CloseUpsIcon } from './closeups.svg';
export { ReactComponent as EndEventIcon } from './endevent.svg';
export { ReactComponent as IntroOutroIcon } from './intro-outro.svg';
export { ReactComponent as MontageIcon } from './montage.svg';
export { ReactComponent as QuickShotsIcon } from './quickshots.svg';
export { ReactComponent as VenueIcon } from './venuedetail.svg';
export { ReactComponent as WideShotsIcon } from './wideshots.svg';
